import React, { useEffect, useState } from "react";
import styles from "./MailAuth.module.css";
import { useNavigate } from "react-router-dom";
import { authCursoLogic } from "../../../Logic/AuthCurso";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (periodo: string) => void; // Se ejecuta cuando el login es correcto
  idCurso: number
}

const MailAuthCurso: React.FC<ModalProps> = ({ isOpen, onClose, onSuccess, idCurso }) => {
    const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [registered, setRegistered] = useState(false);


   useEffect(() => {
     const data = localStorage.getItem("usuarioRegistrado");
   
     if (data){
        const usuarioRegistrado = JSON.parse(data);
        setEmail(usuarioRegistrado.email)
        setRegistered(true); 
     }
        
   }, []);


  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {

        const formData = new FormData();
      formData.append("email", email.trim());
      formData.append("curso_id", idCurso.toString());

       const data = localStorage.getItem("usuarioRegistrado");
   
     if (data){
        const usuarioRegistrado = JSON.parse(data);

        if(email != usuarioRegistrado.email){
             setError("Correo invalido: ingrese el correo con el que originalmente se registró (" + usuarioRegistrado.email + ") e intente de nuevo.");
             return;
        }

     }
        await authCursoLogic.VerificarAccesoCurso(formData).then((response) => {
                if(response.existe && response.acceso)
                    onSuccess(response.periodo);
                else    
                  setError(response.mensaje);
        });

 
    } catch (err) {
      setError("Error al identificar. Intenta de nuevo");
    } finally {
      setLoading(false);
    }
  };

  const goToRegister = () => {
       navigate("/register" ); 
  };

    const handleClose = () => {
        setError("");
    onClose()
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modalContainer}>
        {/* Botón Cerrar (X) */}
        <button className={styles.closeButton} onClick={handleClose}>✖</button>

        {registered ?  <h2 className={styles.title}>IDENTIFÍCATE</h2> : null}
       

        {registered ? 
        <p className={styles.subtitle}>
          Para acceder al contenido del curso, por favor identifícate con tu correo electrónico.
        </p> : <p className={styles.subtitle}>
          Para acceder al contenido del curso, por favor realice su registro primeramente.
        </p> }

 {registered ? 
 <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <label>Correo Electrónico</label>
            <input 
              type="email" 
              placeholder="tu@correo.com" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {error && <p className={styles.errorMessage}>{error}</p>}

          <button type="submit" className={styles.submitButton} disabled={loading}>
            {loading ? "VERIFICANDO..." : "ACCEDER AL CURSO"}
          </button>
        </form> :    <button className={styles.submitButton} onClick={goToRegister}>Ir al Registro</button>
}
        
      </div>
    </div>
  );
};

export default MailAuthCurso;